import { FC, useContext } from 'react';
import { ActivityIndicator } from 'react-native'
import { ThemeContext } from 'styled-components/native'
import { LoaderProps } from './type'

export const Loader: FC<LoaderProps> = (props) => {
  const { type = 'small', color: propColor = 'PRIMARY', testID } = props
  let color = propColor
  const theme = useContext(ThemeContext)
  if (propColor && theme?.colors[propColor]) {
    color = theme.colors[propColor]
  }
  return <ActivityIndicator testID={testID} size={type} color={color} />
}
